import { Outlet, useLocation } from "react-router-dom";
import { BottomNav } from "./BottomNav";
import { LogSheetProvider } from "@/contexts/LogSheetContext";
import { LogMealSheet } from "./forkd/LogMealSheet";

export function AppShell() {
  const location = useLocation();
  // Use the top-level path segment so nested routes (e.g. /u/:username vs
  // /profile) still trigger a subtle fade between bottom-nav tabs.
  const tabKey = "/" + (location.pathname.split("/")[1] ?? "");
  return (
    <LogSheetProvider>
      <div
        className="min-h-screen bg-[var(--colour-background)] text-[var(--colour-text-primary)]"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <main key={tabKey} className="pb-[80px] fkd-route-fade">
          <Outlet />
        </main>
        <BottomNav />
        <LogMealSheet />
      </div>
    </LogSheetProvider>
  );
}
